import { useEffect } from 'react';

const useDfpSlot = ({ path, id }) => {
  useEffect(() => {
 
    const googletag = window.googletag || {};
      googletag.cmd = googletag.cmd || [];
      googletag.cmd.push(() => {
      googletag.defineSlot(path,[[300,250]], id).setTargeting('pos', `shorthand-${id}` ).addService(googletag.pubads());
      // googletag.pubads().collapseEmptyDivs();
      // googletag.pubads().enableSingleRequest(); 
      googletag.enableServices();
      googletag.cmd.push(function() {
        googletag.display(id);
      });

    });
  }, [path, id]);
};

export default useDfpSlot;